// Will this be updated?
export const DEFAULT_AUDIO_URL =
  'https://firebasestorage.googleapis.com/v0/b/televet-83069.appspot.com/o/sounds%2Fappointed.mp3?alt=media&token=52471353-5a9a-4b09-ad17-9703a42875b5';
